module.exports = __webpack_public_path__ + "img/android.1d227219.svg";